import CharmSuggestionsStore from './schema/CharmSuggestionsStore';
import { createStore } from 'satcheljs';
import './mutators/charmSuggestionMutators';

let charmSuggestionsStoreData: CharmSuggestionsStore = {
    highlightedIndex: 0,
    shouldShowSuggestions: false,
    suggestions: [],
};

let charmSuggestionsStore = createStore<CharmSuggestionsStore>(
    'charmSuggestionsStoreData',
    charmSuggestionsStoreData
)();
export default charmSuggestionsStore;

export function getStore() {
    return charmSuggestionsStore;
}
